import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApplicationStore, ApplicationStoreType } from '../store/application.store';
import { whenOrganizationAccessResolved } from './organization-access';
import { AppUrls } from '../../routing/app-urls';

export const juyoAdminGuard: CanActivateFn = () => {
    const applicationStore: ApplicationStoreType = inject(ApplicationStore);
    const router = inject(Router);

    return whenOrganizationAccessResolved(() =>
        applicationStore.isJuyoUser() ? true : router.createUrlTree(['/', AppUrls.hotelGptUrl]),
    );
};
